import {
    CreateAttachmentHandler,
    FileSelectionFilter,
    lazyAttachmentFilePicker,
} from 'owa-attachment-filepicker';
import { lazyGetAvailableLocalAttachmentSize } from 'owa-attachment-well-data';
import {
    fetchUploadFolder,
    getUploadFolder,
    UploadFolder,
    UploadFolderMailboxType,
} from 'owa-attachments-upload-folder';
import { isFeatureEnabled } from 'owa-feature-flags';
import { isGroupTableSelected } from 'owa-group-utils';
import loc from 'owa-localize';
import { action } from 'satcheljs/lib/legacy';
import { ComposeViewState } from 'owa-mail-compose-store';
import { UploadToGroupFiles } from './clickAttachButton.locstring.json';
import trySaveMessage, { isSaving } from './trySaveMessage';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

export default action('clickAttachButton')(async function clickAttachButton(
    isInline: boolean,
    handler: CreateAttachmentHandler,
    viewState: ComposeViewState
) {
    if (!viewState.itemId && !isSaving(viewState)) {
        trySaveMessage(viewState);
    }

    const maximumClassicAttachmentSize = (await lazyGetAvailableLocalAttachmentSize.import())(
        viewState.attachmentWell
    );
    let uploadFolder = getAttachmentUploadFolder(viewState);
    if (!uploadFolder) {
        uploadFolder = await fetchAttachmentUploadFolder(viewState);
    }
    const uploadText = getUploadText(viewState);

    lazyAttachmentFilePicker.importAndExecute(handler, {
        fileSelectionFilter: isInline ? FileSelectionFilter.Images : FileSelectionFilter.None,
        maxAllowedLocalFilesSize: maximumClassicAttachmentSize,
        uploadConfiguration: {
            folderName: uploadFolder ? uploadFolder.folderName : null,
            uploadText: uploadText,
        },
        disableLocalComputerFilePicker: getUserConfiguration().SessionSettings.IsShadowMailbox
            ? true
            : isFeatureEnabled('doc-attachment-upsellEntryPoint'),
    });
});

function getAttachmentUploadFolder(viewState: ComposeViewState): UploadFolder {
    if (isGroupTableSelected() && getGroupId(viewState)) {
        const mailboxId = viewState.attachmentWell.groupId;
        return getUploadFolder(mailboxId);
    }
    return getUploadFolder();
}

async function fetchAttachmentUploadFolder(viewState: ComposeViewState): Promise<UploadFolder> {
    if (isGroupTableSelected() && getGroupId(viewState)) {
        const mailboxId = viewState.attachmentWell.groupId;
        return await fetchUploadFolder(mailboxId, UploadFolderMailboxType.Group);
    }
    return await fetchUploadFolder();
}

function getGroupId(viewState: ComposeViewState): string | null {
    return viewState.attachmentWell && viewState.attachmentWell.groupId;
}

function getUploadText(viewState: ComposeViewState): string | null {
    return isGroupTableSelected() && getGroupId(viewState) ? loc(UploadToGroupFiles) : null;
}
